<template>
  <v-chip :color="color"
          label
          small
          dark
          class="d-block text-center font-weight-bold">
    {{ text }}
  </v-chip>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true,
    }
  },
  computed: {
    color() {
      switch (this.contact.status) {
        case 'Active':
          return 'success';
        case 'Inactive':
          return 'warning';
        default:
          return 'info';
      }
    },
    text() {
      if (this.contact.is_unsubscribed) {
        return 'Unsubscribed';
      }
      return this.contact.status;
    }
  }
}
</script>
